/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Modal } from "react-bootstrap";
import "./index.scss";

export const CustomModal = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div className="csm-wrapper">
        {/* <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Modal heading
        </Modal.Title>
      </Modal.Header> */}
        <Modal.Body>
          <div className="cs-modal">
            <img src={props?.content?.image} alt="" className="project-image" />
            <div>
              <h4 className="project-title">{props?.content?.name}</h4>
              <p className="description">{props?.content?.description}</p>
              <p>
                Visit App:{" "}
                {props?.content?.links?.map((link, index) => (
                  <span>
                    <a target="_blank" href={link?.link} key={index} rel="noopener noreferrer">
                      {link?.name}
                    </a>
                    {index === 2 ? "" : ", "}{" "}
                  </span>
                ))}
              </p>
              <div className="skills">
                {props?.content?.stack?.map((skill, index) => (
                  <p className="skill" key={index}>
                    {skill}
                  </p>
                ))}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="button-wrapper">
            <button onClick={props.onHide}>Close</button>
          </div>
        </Modal.Footer>
      </div>
    </Modal>
  );
};
